import Icon from '../../components/Icon.vue'

Icon.register({"brands/hotjar":{"width":448,"height":512,"paths":[{"d":"M414.9 161.5C340.2 29 121.1 0 121.1 0S222.2 110.4 93 197.7C11.3 252.8-21 324.4 14 402.6 40.8 462.5 97.5 486.9 158.6 496 129.4 440.9 152 373.6 154.5 366.4 211.6 452.8 319.5 366.4 265.3 272.5 336.3 287.9 346.9 411.1 292.4 488 372.9 462.7 426.5 399.1 441.2 342.4 456.7 283.1 444.9 214.5 414.9 161.5z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/hotjar.js
// module id = TrkH
// module chunks = 0